/**
 * DO NOT MODIFY THIS FILE!
 * It was created by the Reefer icons generator.
 * For updates, please re-run the generator.
 */

import type { SVGProps } from 'react';

import type { IconComponentProps } from '../../icon/icon.types';
import { Icon } from '../icon';

const Google = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    fill="none"
    className="Icon/Google"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="#0E0E0E"
      d="M21.77 10.143h-9.524v3.944h5.486c-.511 2.513-2.65 3.953-5.486 3.953a6.04 6.04 0 0 1 0-12.08 5.96 5.96 0 0 1 3.765 1.346l2.973-2.973a10.222 10.222 0 1 0-6.738 17.89C17.357 22.223 22 18.508 22 12a8 8 0 0 0-.23-1.857"
      className="SVG"
    />
  </svg>
);

export const GoogleIcon = ({
  size = 'md',
  'data-testid': testId,
  ...props
}: IconComponentProps) => {
  return (
    <Icon
      data-testid={testId || 'google-icon'}
      icon={Google}
      {...props}
      size={size}
    />
  );
};
